import * as React from "react";

export const Heading = ({ text, className = `` } = {}) => (
    <h1 className={`text-2xl uppercase ${className}`}>{text}</h1>
);
